import { HustleupIcon } from "@images/hustleupIcon"
import { CardioSelectedIcon } from "@images/svgIcons/cardioIcon"
import { GymSelectedIcon } from "@images/svgIcons/gymIcon"
import { WeightliftingSelectedIcon } from "@images/svgIcons/weightliftingIcon"
import { ProfileAvatar } from "@modules/profile/common/components/profileAvatar"
import { ProgramInfiniteSession, ProgramOnOffSession } from "@modules/programSession/programSessionTypes"
import { Program } from "@modules/programs/programTypes"
import { FullscreenExerciseDetails } from "@modules/sessionBlock/exercises/components/fullscreenExerciseDetails"
import { Exercise } from "@modules/sessionBlock/exercises/exerciseTypes"
import { SessionBlockType } from "@modules/sessionBlock/sessionBlockTypes"
import { HUText } from "@modules/ui/components/huText"
import React from "react"
import { useTheme } from "styled-components"

type SessionDetailsContentFullscreenProps = {
  session: ProgramInfiniteSession | ProgramOnOffSession
  program: Program
}

export const SessionDetailsContentFullscreen: React.FC<SessionDetailsContentFullscreenProps> = ({
  session,
  program,
}) => {
  const theme = useTheme()

  return (
    <div className="flex flex-column h-screen overflow-hidden">
      <div className="flex flex-column flex-1 p-6 overflow-auto" style={{ height: "calc(100vh - 30px)" }}>
        <div className="flex">
          <div className="flex-1 pl-5 align-content-center">
            <HUText fontStyle="HL">{session.name}</HUText>
            <div className="flex flex-row justify-content-start align-items-center gap-4 mt-2">
              {session.gymnasticTag && <GymSelectedIcon color="" width={40} height={40} />}
              {session.weightliftingTag && <WeightliftingSelectedIcon color="" width={40} height={40} />}
              {session.cardioTag && <CardioSelectedIcon color="" width={40} height={40} />}

              {program.author && (
                <div className="flex flex-row align-items-center gap-1 ml-3">
                  <ProfileAvatar
                    profile={{ avatar: program.author.avatar, username: program.author.username }}
                    size={48}
                  />
                  <HUText fontStyle="LL" className="event-content ml-2" color={theme.neutralColor700}>
                    {program.author.username}
                  </HUText>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="flex flex-1 pt-6 gap-5">
          {session.blocks
            .filter((block) => block.type === SessionBlockType.SESSION_EXERCISE)
            .map((block, key) => (
              <FullscreenExerciseDetails key={key} exercise={block.content as Exercise} />
            ))}
        </div>
      </div>
      <div className="flex mb-1" style={{ height: 30 }}>
        <HustleupIcon color={theme.mainBlack} width={160} style={{ margin: "auto" }} />
      </div>

      {/*{showLeaderbord &&
              <div className="flex">
                <div style={{
                  backgroundColor: theme.primaryColor,
                  padding: 2,
                  borderRadius: 40,
                  marginTop: 50,
                  marginBottom: 50,
                  marginLeft: 20,
                  marginRight: 20,
                }}></div>
                <div><p>leaderbord</p></div>
              </div>
            }*/}
    </div>
  )
}
